export default "__VITE_ASSET__f87ea9dd__"